import { GridLegacy as Grid, Typography } from '@mui/material'
import { ReactNode } from 'react'

type InfoDrawerDetailFieldProps = {
    label: ReactNode
    value: ReactNode
}

export type InfoDrawerDetailProps = {
    fields: InfoDrawerDetailFieldProps[]
}
export const InfoDrawerDetail = ({ fields }: InfoDrawerDetailProps): React.ReactElement => {
    return <Grid container spacing={1}>
        {
            fields.map((f, i) => <Grid item container key={`info-drawer-detail-${i}`} spacing={1} alignItems="center" mb={1}>
                <Grid item xs={12} md={4}>
                    <Typography variant="h6" component="div">
                        {f.label}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={8}>
                    {f.value}
                </Grid>
            </Grid>)
        }
    </Grid>
}
